import TEFileInput from './TEFileInput';

export default TEFileInput;
